export class EventEmitter {
    constructor() {
        this._listeners = new Map();
    }
    on(type, listener) {
        if (!this._listeners.has(type)) {
            this._listeners.set(type, []);
        }
        this._listeners.get(type).push(listener);
    }
    off(type, listener) {
        if (this._listeners.has(type)) {
            this._listeners.set(type, this._listeners.get(type).filter((val) => val !== listener));
        }
    }
    emit(type, value) {
        var _a;
        (_a = this._listeners.get(type)) === null || _a === void 0 ? void 0 : _a.forEach((listener) => listener(value));
    }
}
export class SafeEventEmitter extends EventEmitter {
    constructor(options) {
        var _a;
        super();
        this.onError = (_a = options === null || options === void 0 ? void 0 : options.onError) !== null && _a !== void 0 ? _a : console.error;
    }
    emit(type, value) {
        var _a;
        (_a = this._listeners.get(type)) === null || _a === void 0 ? void 0 : _a.forEach((listener) => this.safeExec(() => listener(value)));
    }
    safeExec(fn) {
        try {
            fn();
        }
        catch (e) {
            this.onError(e);
        }
    }
}
